const rsTipoSolicitud = [
  { value: '0', detalle: 'Nueva' },
  {
    value: '1',
    detalle: 'Modificación de la existente',
  },
  {
    value: '2',
    detalle: 'Revalidación de la existente',
  },
];

export default rsTipoSolicitud;
